import React, {useState, useEffect} from 'react';
import { documentationService, customerService } from '../../_services'
import { useTranslation } from "react-i18next";
import { Form, Button, Container, Row, Col, Spinner } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { alertActions } from '../../_actions/alert.actions'
import Select from 'react-select'

function CopyDocumentation() {

	const [customers, setCustomers] = useState([])
	const [state, setState] = useState({'documentation': '', 'customer': '', 'name': ''})
	const [copying, setCopying] = useState(false)
	const dispatch = useDispatch();
	const {t} = useTranslation('common')

	useEffect(() => {
	    customerService.getOptions().then(customers => {
		    customers.sort((a, b) => a.name.localeCompare(b.name))
			setCustomers(customers)
			if (!state.customer && customers.length > 0) {
                handleChange({target: {type: "select", name: "customer", value: customers[0].id}})
            }
	    })
	}, [])

	const getCustomer = (customerId) => {
		var customer = customers.find(customer => customer.id == customerId)
	    if (customer) {
	        return customer.name
	    }
	    return '-'
	}

	const handleChange = (e) => {
		console.log('handleChange')
	    const target = e.target
	    const name = target.name
	    console.log(name)
	    const value = target.value
	    console.log(value)
	    console.log(state)
	    setState( prevState => ({
	        ...prevState,
	        [name]: value
	    }))
	    console.log(state)
	}

	const submit = event => {
		console.log('submit')
		console.log(state)

		dispatch(alertActions.clear());
		setCopying(true)

		event.preventDefault()
        event.stopPropagation()

        console.log(state.documentation)
        console.log(state.customer)
        console.log(state.name)

        documentationService.copy(state.documentation, state.customer, state.name).then(data =>  {
			console.log(data)
			dispatch(alertActions.success(t('alerts.createsuccessful')))

			setCopying(false)
		})
	}

	return (
		<Container style={{paddingTop: '25px'}}>
			<h2>
				Kopiera dokumentation
			</h2>
			{ customers &&
				<Row>
					<Col md={{ span: 6, offset: 0 }}>
						<Form id="documentation-form" onSubmit={submit}>
				            <Form.Group controlId="documentation">
				                <Form.Label>
				                    Dokumentation *
				                </Form.Label>
				                <Form.Control type="text" placeholder="Dokumentation" name="documentation" value={state.documentation} onChange={handleChange} />
				            </Form.Group>
				            <Form.Group controlId="customer">
				                <Form.Label>
				                    Kund *
				                </Form.Label>
				                <Form.Control as="select" placeholder="Kund" name="customer" onChange={handleChange} required>
				                    <option value="">Välj kund</option>
				                    { customers.map(customer => (
				                        <option key={customer.id} value={customer.id}>{customer.name}</option>
				                    ))}
				                </Form.Control>
				            </Form.Group>
				            <Form.Group controlId="name">
				                <Form.Label>
				                    Nytt namn
				                </Form.Label>
				                <Form.Control type="text" placeholder="Nytt namn" name="name" value={state.name} onChange={handleChange} />
				            </Form.Group>
						</Form>
						<Button form='documentation-form' type="submit" variant="primary" disabled={copying}>
							{ !copying &&
								<>
									Kopiera
								</>
							}
							{ copying &&
								<>
									Kopierar
									&nbsp;
						            <Spinner animation="border" role="status" size="sm">
										<span className="sr-only">Loading...</span>
									</Spinner>
								</>
							}
						</Button>
					</Col>
				</Row>
			}
		</Container>
	)
}

export default CopyDocumentation;